import NotFound from "@pages/not-found";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/not-found")({
	component: NotFound,
});
